import type React from "react";

import { useState } from "react";

export function useMultiStepForm(steps: React.ReactElement[]) {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const isFirstStep = currentStepIndex === 0;
  const isLastStep = currentStepIndex === steps.length - 1;

  const next = () => {
    setCurrentStepIndex((prev) => {
      if (prev >= steps.length - 1)
        return prev;
      return prev + 1;
    });
  };

  const prev = () => {
    setCurrentStepIndex((prev) => {
      if (prev <= 0)
        return prev;
      return prev - 1;
    });
  };

  const reset = () => {
    setCurrentStepIndex(0);
  };

  const goto = (index: number) => {
    setCurrentStepIndex(index);
  };

  return {
    currentStepIndex,
    step: steps[currentStepIndex],
    steps,
    isFirstStep,
    isLastStep,
    next,
    prev,
    goto,
    reset,
  };
}
